import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { REPOS_KEYS, SUPPLIERS_ROUTES } from '@wellbeingxltd/fe-lib/constants'
import { isAuthenticated } from 'awsApi'

import Container from 'modules/Container'
import Login from '../Landing/Login'
import SignUp from '../Landing/SignUp'
import ConfirmSignup from '../Landing/ConfirmSignup'
import ForgotPassword from '../Landing/ForgotPassword'
import Onboarding from '../Landing/Onboarding'
import { Register } from 'modules/Landing/Register'
import { ConfirmOnboarding } from 'modules/Landing/ConfirmOnboarding'
import { Voucher } from 'modules/Voucher'
import { Vouchers } from 'modules/Vouchers'
import Transactions from '../Transactions'
import Transaction from '../Transaction'
import Directory from '../Directory'
import Invoices from '../Invoices'
import { Shopify } from '../Shopify'
import Settings from '../Settings'
import Tickets from '../Tickets'
import { ScrollToTop } from 'components'
import NoAccessPage from '../Container/NoAccessPage'

const isConfirmingSignup = localStorage.getItem('confirmSignup')

const Routes = () => (
    <BrowserRouter forceRefresh={!isAuthenticated(REPOS_KEYS.SUPPLIER)}>
        <ScrollToTop />
        {isAuthenticated(REPOS_KEYS.SUPPLIER) && (
            <Switch>
                <Route exact path={SUPPLIERS_ROUTES.ONBOARDING.onboarding} component={Onboarding} />
                <Route exact path={SUPPLIERS_ROUTES.ONBOARDING.register} component={Register} />
                <Route exact path={SUPPLIERS_ROUTES.ONBOARDING.confirmOnboarding} component={ConfirmOnboarding} />
                <Route
                    render={props => (
                        <Container {...props}>
                            <Switch>
                                <Route exact path={`${SUPPLIERS_ROUTES.TRANSACTIONS.transaction}/:id`} component={Transaction} />
                                <Route exact path={SUPPLIERS_ROUTES.TRANSACTIONS.transactions} component={Transactions} />
                                <Route exact path={SUPPLIERS_ROUTES.DIRECTORY.directory} component={Directory} />
                                <Route exact path={SUPPLIERS_ROUTES.NO_ACCESS} component={NoAccessPage} />
                                <Route exact path={SUPPLIERS_ROUTES.INVOICES.invoices} component={Invoices} />
                                <Route exact path={SUPPLIERS_ROUTES.SHOPIFY.shopify} component={Shopify} />
                                <Route exact path={SUPPLIERS_ROUTES.SETTINGS.settings} component={Settings} />
                                <Route exact path={`${SUPPLIERS_ROUTES.TRANSACTIONS.tickets}/:id`} component={Tickets} />
                                <Route exact path={SUPPLIERS_ROUTES.VOUCHERS.vouchers} component={Vouchers} />
                                <Route exact path={`${SUPPLIERS_ROUTES.VOUCHERS.voucher}/:id`} component={Voucher} />
                                <Redirect to={SUPPLIERS_ROUTES.ONBOARDING.onboarding} />
                            </Switch>
                        </Container>
                    )}
                />
                <Redirect to={SUPPLIERS_ROUTES.ONBOARDING.onboarding} />
            </Switch>
        )}
        {!isAuthenticated(REPOS_KEYS.SUPPLIER) && (
            <Switch>
                <Route path={SUPPLIERS_ROUTES.NOT_AUTHENTICATED.login} component={Login} />
                <Route path={SUPPLIERS_ROUTES.NOT_AUTHENTICATED.forgotPassword} component={ForgotPassword} />
                <Route path={SUPPLIERS_ROUTES.NOT_AUTHENTICATED.signup} component={SignUp} />
                <Route path={SUPPLIERS_ROUTES.NOT_AUTHENTICATED.confirmSignup} component={ConfirmSignup} />
                <Redirect to={!!isConfirmingSignup ? SUPPLIERS_ROUTES.NOT_AUTHENTICATED.confirmSignup : SUPPLIERS_ROUTES.NOT_AUTHENTICATED.login} />
            </Switch>
        )}
    </BrowserRouter>
)

export default Routes
